/**
 * ACCUEIL — la vitrine des bonnes affaires (maquette validée le 2026-09-14).
 *
 * « ZENKART = LES BONNES AFFAIRES. » On ne DEMANDE rien au visiteur avant de
 * lui MONTRER quelque chose : un bandeau de deux lignes, puis immédiatement la
 * grille des meilleures affaires, triées par écart à la cote en pourcentage.
 * Trois filtres légers en pilules ; la recherche est dans l'en-tête. Tout en
 * bas seulement, une ligne sur la méthode et les autres usages.
 *
 * « en ce moment » et pas « aujourd'hui » : les annonces ne sont pas toutes
 * revues chaque jour, chaque carte dit depuis quand elle a été vue.
 */
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Layout/Navbar';
import FiltresAffaires from '../components/Affaires/FiltresAffaires';
import GrilleAffaires from '../components/Affaires/GrilleAffaires';
import useAffaires from '../components/Affaires/useAffaires';
import { ecrireCriteres } from '../components/Affaires/criteres';
import { nombre } from '../components/Affaires/format';
import api from '../services/api';
import '../components/Affaires/Affaires.css';

const DIMS = [
  { cle: 'budget', titre: 'Budget' },
  { cle: 'departement', titre: 'Département' },
  { cle: 'marque', titre: 'Marque' },
];
const PAR_PAGE = 24;

function memoriserProfil(profil) {
  api.post('/api/track/visit', { path: '/landing-choice', profil }).catch(() => {});
  try { localStorage.setItem('zk_profil', profil); } catch { /* navigation privée */ }
}

export default function LandingPage() {
  const [criteres, setCriteres] = useState({});
  const [plus, setPlus] = useState(false);
  const { donnees, chargement, erreur } = useAffaires({ ...criteres, par_page: plus ? PAR_PAGE * 2 : PAR_PAGE });
  const lienTout = ecrireCriteres(criteres);

  return (
    <>
      <Navbar />
      <main className="zk-vit">
        <section className="zk-vit-tete">
          <h1>Les voitures vendues sous leur valeur, en ce moment</h1>
          <p>
            {donnees && <><b>{nombre(donnees.annonces_comparees)}</b> annonces comparées. </>}
            Voici celles qui valent le coup.
          </p>
          {/* Entrées acheteur et vendeur, sous le bandeau, avant la grille — la
              vitrine reste ce qu'on montre en premier (refonte du 2026-09-14).
              L'acheteur a un BOUTON depuis le 2026-10-15 : c'est l'entrée
              qu'on veut voir prise, pas une ligne de texte de plus. Le
              vérificateur, qui occupait cette place, est supprimé. */}
          <Link to="/trouver" className="zk-vit-trouver">
            Dites-nous la voiture que vous cherchez, on la trouve
          </Link>
          <p className="zk-vit-vendre">
            Vous vendez la vôtre ? <Link to="/vendre">Estimation gratuite et offres de garages →</Link>
          </p>
        </section>

        <FiltresAffaires
          dims={DIMS}
          facettes={donnees?.facettes}
          criteres={criteres}
          onChange={(c) => { setCriteres(c); setPlus(false); }}
          total={donnees?.total}
        />

        <GrilleAffaires
          donnees={donnees}
          chargement={chargement}
          erreur={erreur}
          onEffacer={() => setCriteres({})}
        />

        {donnees && donnees.total > 0 && (
          <div className="zk-vit-suite">
            {!plus && donnees.total > PAR_PAGE && (
              <button type="button" className="zk-vit-plus" onClick={() => setPlus(true)}>
                Afficher plus d’affaires
              </button>
            )}
            <Link to={lienTout ? `/explore?${lienTout}` : '/explore'} className="zk-vit-tout">
              Voir les {nombre(donnees.total)} bonnes affaires
            </Link>
          </div>
        )}

        <section className="zk-vit-methode">
          <p>
            Chaque annonce est comparée aux voitures identiques en vente en France — même modèle,
            même âge, même kilométrage. Une bonne affaire est au moins 10 % sous cette cote.
            Aucune cote extérieure : l’écart affiché est celui du marché réel.
          </p>
          <nav aria-label="Autres usages">
            <Link to="/vendre">Vendre ma voiture →</Link>
            <Link to="/trouver">Trouvez ma voiture →</Link>
            <Link to="/garage" onClick={() => memoriserProfil('garage')}>Garage →</Link>
          </nav>
        </section>
      </main>
    </>
  );
}
